export default [
  {
    value: "01:00",
    label: "1AM",
  },
  {
    value: "02:00",
    label: "2AM",
  },
  {
    value: "03:00",
    label: "3AM",
  },
  {
    value: "04:00",
    label: "4AM",
  },
  {
    value: "05:00",
    label: "5AM",
  },
  {
    value: "06:00",
    label: "6AM",
  },
  {
    value: "07:00",
    label: "7AM",
  },
  {
    value: "08:00",
    label: "8AM",
  },
  {
    value: "09:00",
    label: "9AM",
  },
  {
    value: "10:00",
    label: "10AM",
  },
  {
    value: "11:00",
    label: "11AM",
  },
  {
    value: "12:00",
    label: "12PM",
  },
  {
    value: "13:00",
    label: "1PM",
  },
  {
    value: "14:00",
    label: "2PM",
  },
  {
    value: "15:00",
    label: "3PM",
  },
  {
    value: "16:00",
    label: "4PM",
  },
  {
    value: "17:00",
    label: "5PM",
  },
  {
    value: "18:00",
    label: "6PM",
  },
  {
    value: "19:00",
    label: "7PM",
  },
  {
    value: "20:00",
    label: "8PM",
  },
  {
    value: "21:00",
    label: "9PM",
  },
  {
    value: "22:00",
    label: "10PM",
  },
  {
    value: "23:00",
    label: "11PM",
  },
  {
    value: "24:00",
    label: "12AM",
  },
];
